import { render, staticRenderFns } from "./BackendBlock.vue?vue&type=template&id=71b50ed0&"
import script from "./BackendBlock.vue?vue&type=script&lang=js&"
export * from "./BackendBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports